import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', (value) => {
  if (value || value === 0) {
    return moment.utc(value).format('HH:mm:ss')
  }
})